export type RelaySettingsProps = {
  deviceId: string;
  dawnTime?: string;
  duskTime?: string;
  withMelody: boolean;
}


export type RelaySettingsParams = {
  relays: {
    0: {
      enabled: boolean;
      mode: RelayModeValue;
    },
    1: {
      enabled: boolean;
      mode: RelayModeValue;
    }
  },
  amplifierRelayEnabled: boolean;
  speakerRelayEnabled: boolean;
}

export type RelayDescriptions = {
  relays: {
    0: {
      number: number;
      description: string;
    },
    1: {
      number: 1,
      description: string;
    }
  }
}

export type RelayTime = {
  schedulers: {
    [key: string]: {
      onTime: string;
      offTime: string;
    };
  };
}

export type DuskDawnTimeResponse = {
  onTime?: string | null;
  offTime?: string | null;
}

export type RelayTimeLocal = {
  onHour: number;
  onMinute: number;
  offHour: number;
  offMinute: number;
}

export type RelayTimeUpdatePayload = {
  relayNumber: number;
  onTime: string;
  offTime: string;
}

export type Coordinates = {
  coordinateSource?: 'Manual' | 'Gps';
  latitudeDirection: string;
  latitude: string;
  longitudeDirection: string;
  longitude: string;
}

export type GlonassRelayData = {
  isManual: "Manual" | "Gps";
  latitudeDirection: "N" | "S";
  latitude: string;
  longitudeDirection: "E" | "W";
  longitude: string;
};

export type GlonassRelayProps = {
  executeCommand?: (...args: unknown[]) => Promise<unknown>;
  channel?: string | number;
  deviceId: string | number;
  onAfterWrite?: () => Promise<void> | void;
  dawnTime?: string | null;
  duskTime?: string | null;
};

export type GlonassRelayHandle = {
  refresh: () => Promise<void>;
  update: () => Promise<void>;
};

export type MapCoordinates = {
  latitude: string;
  longitude: string;
};

export type RelayListControlProps = {
  executeCommand?: (...args: unknown[]) => Promise<unknown>;
  deviceId: string | number;
  onAfterTimeRelayWrite?: () => Promise<void> | void;
  dawnTime?: string | null;
  duskTime?: string | null;
  refreshDuskDawn?: () => Promise<void> | void;
};

export const DEFAULT_COORDS: GlonassRelayData = {
  isManual: "Manual",
  latitudeDirection: "N",
  latitude: "055.7512",
  longitudeDirection: "E",
  longitude: "037.6184"
};

export enum RelayModeValue {
  Disabled = "Disabled",
  AlwaysOn = "AlwaysOn",
  AlwaysOff = "AlwaysOff",
  ConnectedToTimeRelay1 = "ConnectedToTimeRelay1",
  ConnectedToTimeRelay2 = "ConnectedToTimeRelay2",
  ConnectedToAstronomicalRelay = "ConnectedToAstronomicalRelay",
}

export const RELAY_MODE: Record<RelayModeValue, string> = {
  [RelayModeValue.Disabled]: "Отключено (работает по расписанию, если есть)",
  [RelayModeValue.AlwaysOn]: "Всегда включено",
  [RelayModeValue.AlwaysOff]: "Всегда выключено",
  [RelayModeValue.ConnectedToTimeRelay1]: "Подключено к «Реле времени 1»",
  [RelayModeValue.ConnectedToTimeRelay2]: "Подключено к «Реле времени 2»",
  [RelayModeValue.ConnectedToAstronomicalRelay]: "Подключено к «Астрономическому реле»",
};
